import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { baseQueryWithAuthInterceptor } from "./util";

export const vehicleTypesApi = createApi({
  reducerPath: "vehicleTypesApi",
  baseQuery: baseQueryWithAuthInterceptor({ baseUrl: "/api/vehicleTypes" }),
  tagTypes: ["VehicleType"],
  endpoints: (builder) => ({
    getVehicleTypes: builder.query({
      query: () => "",
      providesTags: ["VehicleType"],
    }),
  })
})

export const {
  useGetVehicleTypesQuery,
} = vehicleTypesApi